import React, { FC } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Title from 'antd/lib/typography/Title';
import { Tag } from 'antd';

const useStyles = makeStyles(({ spacing, colors }) => ({
  root: {
    padding: spacing(4, 3),
    marginBottom: spacing(6.5)
  },
  header: {
    marginBottom: spacing(2)
  },
  description: {
    fontSize: 12,
    fontWeight: 400,
    color: colors.greySlate,
    backgroundColor: colors.whiteSmoke
  },
  spacing: {
    '& > *:not(:last-child)': {
      marginRight: spacing(1)
    }
  }
}));

interface IProps {
  title?: string;
  description?: string;
}

const DrawerContent: FC<IProps> = ({ title, description, children }) => {
  const classes = useStyles();

  return (
    <Grid container direction="column" wrap="nowrap" className={classes.root}>
      <Grid container className={clsx(classes.header, classes.spacing)}>
        {title && <Title level={5}>{title}</Title>}
        {description && <Tag className={classes.description}>{description}</Tag>}
      </Grid>
      {children}
    </Grid>
  );
};

export default DrawerContent;
